import { CommonModule, DOCUMENT } from '@angular/common';
import { HttpClient } from '@angular/common/http';
import { Component, Inject, inject, OnInit, signal } from '@angular/core';
import { RouterModule } from '@angular/router';
import { ToggleThemeService } from '@corporate-tailwind/widget';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-fp-footer',
    templateUrl: './fp-footer.component.html',
    styleUrls: ['./fp-footer.component.scss'],
    imports: [CommonModule, TranslateModule, RouterModule]
})
export class FpFooterComponent implements OnInit {
    protected version = signal('');
    private http = inject(HttpClient)
    currentYear = new Date().getFullYear();

    constructor(public _toggleThemeService: ToggleThemeService) { }

    ngOnInit(): void {
        this.http.get(`api/version`, { responseType: 'text' }).subscribe((response: string) => {
            this.version.set(response)
        })
        
        //-->remplacement par isDark de toggleService
        // this.updateLogo()
        // // Optionnel : écouter les changements de thème si tu ajoutes/enlèves `dark` dynamiquement
        // const observer = new MutationObserver(() => this.updateLogo())
        // observer.observe(this.document.documentElement, {
        //     attributes: true,
        //     attributeFilter: ['class'],
        // })
    }

    // private updateLogo(): void {
    //     const hasDark = this.document.documentElement.classList.contains('dark')
    //     this.logoSrc = hasDark
    //         ? 'images/logo_loomisFx.png' //'images/logo_loomisFx_dark.png'
    //         : 'images/logo_loomisFx.png'
    // }
}
